import classNames from "classnames";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { useMount } from "../../hooks";
import "./style.scss";
import { RichText } from "@sitecore-jss/sitecore-jss-react";

export default function Textarea({ value, pattern, label, infoMessage, warningMessage, showError, maxLength, onFocus = () => {}, onChange = () => {}, className, clearValue }) {
  const [textareaValue, setTextareaValue] = useState(value);
  const [hasFocus, setHasFocus] = useState(false);

  const onTextareaChange = event => {
    if (maxLength !== undefined) {
      if (event.target.value.length <= maxLength) {
        setTextareaValue(event.target.value);
        if (typeof onChange === "function") onChange(event);
      } else {
        event.preventDefault();
      }
    } else {
      setTextareaValue(event.target.value);
      if (typeof onChange === "function") onChange(event);
    }
  };
  const onBlur = () => {
    setHasFocus(false);
  };

  const onTextAreaFocus = () => {
    setHasFocus(true);
    if (typeof onFocus === "function") onFocus();
  };

  useMount(() => {
    onBlur();
  });

  useEffect(() => {
    clearValue && setTextareaValue("");
  }, [clearValue]);

  // let model = this.props;
  const textAreaGroupClasses = classNames("textarea-group", {
    "show-warning": showError
  });
  const textareaClasses = classNames(
    "text-field__textarea",
    {
      "has-content": (value && value.length > 0) || (textareaValue && textareaValue.length > 0)
    },
    {
      "show-warning": showError
    }
  );

  const labelClasses = classNames("floating-label", {
    "floating-above": hasFocus || (value && value.length > 0) || (textareaValue && textareaValue.length > 0)
  });
  const outlineLeadingClasses = classNames("notched-outline__leading", {
    focus: hasFocus,
    "show-warning": showError
  });
  const outlineNotchClasses = classNames("notched-outline__notch", {
    focus: hasFocus,
    "has-content": textareaValue && textareaValue.length > 0,
    "show-warning": showError
  });
  const outlineTrailingClasses = classNames("notched-outline__trailing", {
    focus: hasFocus,
    "show-warning": showError
  });
  return (
    <div className={"textarea-wrapper " + className}>
      <div className={"textarea-row"}>
        <div className={textAreaGroupClasses}>
          <textarea rows="5" value={textareaValue} className={textareaClasses} onChange={evt => onTextareaChange(evt)} onBlur={evt => onBlur(evt)} onFocus={evt => onTextAreaFocus(evt)} pattern={pattern} />
          <div className={"notched-outline"}>
            <div className={outlineLeadingClasses}></div>
            <div className={outlineNotchClasses}>
              {label && (
                <label htmlFor="tf-outlined" className={labelClasses}>
                  {label}
                </label>
              )}
            </div>
            <div className={outlineTrailingClasses}></div>
          </div>
        </div>
      </div>
      {maxLength && (
        <div className="max-length">
          <label>
            {(textareaValue && textareaValue.length) || 0}/{maxLength}
          </label>
        </div>
      )}
      {showError && <span className="warning-message">{warningMessage}</span>}
      {infoMessage != null && <RichText tag="div" className="info-message" field={infoMessage} />}
    </div>
  );
}

Textarea.propTypes = {
  value: PropTypes.string,
  pattern: PropTypes.string,
  label: PropTypes.string,
  warningMessage: PropTypes.string,
  infoMessage: PropTypes.object,
  showError: PropTypes.bool,
  maxLength: PropTypes.number,
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  className: PropTypes.string
};
Textarea.defaultProps = {
  className: ""
};
